<!--
  Grey wrapper continues the sheet's grey label band; each requested period
  renders as a bordered white inset box. Nothing renders when no period resolves.
-->
<div class="financial-period-band" *ngIf="rows.length">
  <div class="period-box" *ngFor="let row of rows; trackBy: trackByPeriod">
    <span class="period-range">{{ row.range }}</span>
    <span class="period-caption" *ngIf="row.caption">({{ row.caption }})</span>
  </div>
</div>
